var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var getCheckboxItems = function (stateKeys, options) {
    if (options === void 0) { options = {}; }
    var checkboxItems = stateKeys.map(function (stateKey) {
        var _a, _b, _c;
        var labelText = (_b = (_a = options.labelTextMap) === null || _a === void 0 ? void 0 : _a.get(stateKey)) !== null && _b !== void 0 ? _b : stateKey;
        var labelLink = (_c = options.labelLinkMap) === null || _c === void 0 ? void 0 : _c.get(stateKey);
        return {
            checkboxStateKey: stateKey,
            labelText: labelText,
            labelLink: labelLink
        };
    });
    if (options.alphabetize != true) {
        return checkboxItems;
    }
    if (options.selectAllCheckbox === true) {
        var baseCheckboxList = checkboxItems
            .slice(1)
            .sort(function (_a, _b) {
            var labelTextA = _a.labelText;
            var labelTextB = _b.labelText;
            return labelTextA.localeCompare(labelTextB);
        });
        return __spreadArray([checkboxItems[0]], baseCheckboxList, true);
    }
    return checkboxItems.sort(function (_a, _b) {
        var labelTextA = _a.labelText;
        var labelTextB = _b.labelText;
        return labelTextA.localeCompare(labelTextB);
    });
};
